import type { FC } from 'react';
import { HotelInput } from '../../Forms/HotelForm/types';
import HotelIcon from '@material-ui/icons/HotelOutlined';
import TrashIcon from '@material-ui/icons/DeleteOutlined';
import { IconButton } from '@material-ui/core';
import { formatMonthDayYear } from '../../../../utils/utils';

interface Props {
  hotel: HotelInput;
  onDelete?: (id: string) => void;
  onEdit?: () => void;
}

const HotelSummaryItem: FC<Props> = ({ hotel, onDelete, onEdit }) => {
  const handleDelete = () => {
    if (hotel.id) {
      onDelete?.(hotel.id);
    }
  };

  return (
    <div onClick={onEdit} className="flex items-top justify-between px-3 py-2 hover:bg-gray-50 hover:cursor-pointer">
      <div className="flex items-top">
        <HotelIcon className="text-blue-800 mr-4" />
        <div>
          <span className="font-bold">{hotel.hotel?.name}</span>
          <div className="text-xs">
            {formatMonthDayYear(+hotel.checkIn)} - {formatMonthDayYear(+hotel.checkOut)}
          </div>
        </div>
      </div>
      {onDelete && (
        <div>
          <IconButton
            aria-label="delete"
            size="small"
            className="mt-1"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
          >
            <TrashIcon className="text-red-500" />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default HotelSummaryItem;
